import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import CollectionFilters from "./CollectionFilters";

import SortByDropdown from "./SortByDropdown";
import Filters from "./Filters";
import Header from "./Header";
import Footer from "./components/Footer";
import PageLoader from "./components/PageLoader";

import ActivityList from "./ActivityList";
import MainBanner from "./MainBanner";

import { ROOT_API_PATH } from "./actions/constant";
import {
  contentLoading,
  loadActivities,
  saveFilteredActivities,
  changeStatusOfFilter,
  saveFilteredCategory,
  saveFilteredLocation
} from "./actions/index";
import "./css/App.css";
// import { PageNotFound } from './PageNotFound';

class CollectionDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collectionList: [],
      currentCollection: {},
      activities: [],
      loading: true,
      activityCount: 0,
      filters: {
        category: [],
        location: []
      },
      filterdActivity: []
    };
  }
  sortBy = (id, name) => {
    var activities = this.props.filters.status
      ? this.props.filters.activities
      : this.props.activities;
    this.props.contentLoading(true);
    switch (id) {
      case "rating-h-l":
        activities.sort(function(a, b) {
          return b.rating - a.rating;
        });
        break;
      case "rating-l-h":
        activities.sort(function(a, b) {
          return a.rating - b.rating;
        });
        break;
      case "duration-l-h":
        activities.sort(function(a, b) {
          var dateA = new Date(a.duration),
            dateB = new Date(b.duration);
          return dateA - dateB;
        });
        break;
      case "duration-h-l":
        activities.sort(function(a, b) {
          var dateA = new Date(a.duration),
            dateB = new Date(b.duration);
          return dateB - dateA;
        });
        break;
      case "popularity":
        activities.sort(function(a, b) {
          return b.view_count - a.view_count;
        });
        break;
      case "price-l-h":
        activities.sort(function(a, b) {
          var priceA = parseInt(a.price.split(" ")[1], 10);
          var priceB = parseInt(b.price.split(" ")[1], 10);
          return priceA - priceB;
        });
        break;
      case "price-h-l":
        activities.sort(function(a, b) {
          var priceA = parseInt(a.price.split(" ")[1], 10);
          var priceB = parseInt(b.price.split(" ")[1], 10);
          return priceB - priceA;
        });
        break;
      default:
        break;
    }
    this.props.sortedActivitites(activities);
    setTimeout(() => {
      this.props.contentLoading(false);
    }, 1000);
  };
  filterActivities = (id, name) => {};
  componentDidMount() {
    if (this.props.pageLoading) {
      ReactDOM.render(<PageLoader />, document.getElementById("page-loader"));
    }
    window.addEventListener("scroll", this.handleScroll);
  }
  locationFilter = event => {
    var value = event.target.value;
    var currentLocations = this.props.filters.location;
    var newLocations = [];

    if (currentLocations.indexOf(value) !== -1) {
      newLocations = currentLocations.filter(element => {
        if (element !== value) {
          return element;
        }
        return false;
      });
    } else {
      newLocations = [...currentLocations, value];
    }

    var filteredActivity = [];
    if (newLocations.length) {
      if (this.props.filterdActivity.length) {
        filteredActivity = this.props.filterdActivity.filter(element => {
          for (let index = 0; index < element.location_id.length; index++) {
            if (newLocations.includes(element.location_id[index])) {
              return element;
            }
          }
          return false;
        });
      } else {
        filteredActivity = this.props.activities.filter(element => {
          for (let index = 0; index < element.location_id.length; index++) {
            if (newLocations.includes(element.location_id[index])) {
              return element;
            }
          }
          return false;
        });
      }
      this.props.contentLoading(true);
      this.props.filterApplied(true);
      this.props.saveFilteredActivities(filteredActivity);
      this.props.saveFilteredLocation(newLocations);
    } else {
      if (this.props.filters.category.length) {
        var newCategories = this.props.filters.category;
        filteredActivity = this.props.activities.filter(element => {
          for (let index = 0; index < element.category_id.length; index++) {
            if (newCategories.includes(element.category_id[index])) {
              return element;
            }
          }
          return false;
        });
        this.props.contentLoading(true);
        this.props.filterApplied(true);
        this.props.saveFilteredActivities(filteredActivity);
        this.props.saveFilteredLocation(newLocations);
      } else {
        filteredActivity = this.props.activities;
        this.props.contentLoading(true);
        this.props.filterApplied(false);
        this.props.saveFilteredActivities([]);
        this.props.saveFilteredLocation([]);
      }
    }

    setTimeout(() => {
      this.props.contentLoading(false);
    }, 1500);
  };
  categoryFilter = event => {
    var value = event.target.value;
    var currentCategories = this.props.filters.category;
    var newCategories = [];
    var filteredActivity = [];
    if (currentCategories.indexOf(value) !== -1) {
      newCategories = currentCategories.filter(element => {
        if (element !== value) {
          return element;
        }
        return false;
      });
    } else {
      newCategories = [...currentCategories, value];
    }

    if (newCategories.length) {
      filteredActivity = this.props.activities.filter(element => {
        for (let index = 0; index < element.category_id.length; index++) {
          if (newCategories.includes(element.category_id[index])) {
            return element;
          }
        }
        return false;
      });
      this.props.contentLoading(true);
      this.props.filterApplied(true);
      this.props.saveFilteredActivities(filteredActivity);
      this.props.saveFilteredCategory(newCategories);
    } else {
      if (this.props.filters.location.length) {
        var newLocations = this.props.filters.location;
        filteredActivity = this.props.activities.filter(element => {
          for (let index = 0; index < element.location_id.length; index++) {
            if (newLocations.includes(element.location_id[index])) {
              return element;
            }
          }
          return false;
        });
        this.props.contentLoading(true);
        this.props.filterApplied(true);
        this.props.saveFilteredActivities(filteredActivity);
        this.props.saveFilteredCategory(newCategories);
      } else {
        filteredActivity = this.props.activities;
        this.props.contentLoading(true);
        this.props.filterApplied(false);
        this.props.saveFilteredActivities(filteredActivity);
        this.props.saveFilteredCategory(newCategories);
      }
    }
    setTimeout(() => {
      this.props.contentLoading(false);
    }, 1500);
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {};
  render() {
    if (this.props.pagenotfound) {
      window.location.href = ROOT_API_PATH + "error.php";
    }
    return (
      <div className="container-fluid" id="main-page-container">
        <div className="collectionBanner">
          <div
            className="header"
            style={{
              height: 50,
              width: "100%",
              position: "absolute",
              backgroundColor: "transparent",
              zIndex: 1
            }}
          >
            <Header
              affiliateLogo={this.props.affiliateLogo}
              affiliateName={this.props.affiliateName}
            />
          </div>
          <MainBanner />
        </div>
        <div
          className="filters"
          style={{ backgroundColor: "rgb(255,255,255)" }}
        >
          <div className="container row">
            <div className="collection-filter col-xl-8 col-lg-8 col-sm-7 col-md-6">
              <CollectionFilters
                currentCollection={
                  this.props.currentCollection
                    ? this.props.currentCollection.collection_name
                    : ""
                }
                currentCollectionId={
                  this.props.currentCollection
                    ? this.props.currentCollection.collection_id
                    : ""
                }
                collectionList={this.props.fromAffiliate}
                filterActivities={this.filterActivities}
                affiliateUsername={this.props.affiliateUsername}
                collectionUrl={"/af/" + this.props.match.params.username + "/"}
              />
            </div>
            <div className="sort-by col-xl-2 col-lg-2 col-sm-5 col-md-3">
              <SortByDropdown sortBy={this.sortBy} itemSelected={this.sortBy} />
            </div>
            <div className="filter-by col-xl-2 col-lg-2 offset-sm-4 col-sm-4 col-md-3">
              <Filters
                destination={
                  this.props.currentCollection
                    ? this.props.currentCollection.dest_tags
                    : []
                }
                category={
                  this.props.currentCollection
                    ? this.props.currentCollection.cat_tags
                    : []
                }
                categoryFilter={this.categoryFilter}
                locationFilter={this.locationFilter}
                // closeFilter = {this.closeFilter}

                filterApplied={this.props.filters.status}
                locationFilterApplied={this.props.filters.location}
                categoryFilterApplied={this.props.filters.category}
              />
            </div>
          </div>
          <div id="filters-list" />
        </div>
        <div
          className="container-fluid"
          style={{ backgroundColor: "rgb(255,255,255)" }}
        >
          <div className="container activity-list">
            <ActivityList />
            <div className="row">
              <div className="filter-by mobile">
                <Filters
                  destination={
                    this.props.currentCollection
                      ? this.props.currentCollection.dest_tags
                      : []
                  }
                  category={
                    this.props.currentCollection
                      ? this.props.currentCollection.cat_tags
                      : []
                  }
                  categoryFilter={this.categoryFilter}
                  locationFilter={this.locationFilter}
                  // closeFilter = {this.closeFilter}
                  filterApplied={this.props.filters.status}
                  locationFilterApplied={this.props.filters.location}
                  categoryFilterApplied={this.props.filters.category}
                />
              </div>
            </div>
          </div>
          {/*container*/}
        </div>
        {/*container-fluid*/}
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    activities: state.activities,
    filters: state.filters,
    contentLoading: state.contentLoading,
    pageLoading: state.pageLoading,
    currentCollection: state.collections.current,
    fromAffiliate: state.collections.fromAffiliate,
    filterdActivity: state.filters.activities,
    affiliateLogo: state.affiliateLogo,
    affiliateUsername: state.affiliateUsername,
    affiliateName: state.affiliateName,
    pagenotfound: state.pageNotFound
  };
};

const mapDispatchToProps = dispatch => {
  return {
    contentLoading: bool => dispatch(contentLoading(bool)),
    sortedActivitites: activities => dispatch(loadActivities(activities)),
    saveFilteredActivities: activities =>
      dispatch(saveFilteredActivities(activities)),
    filterApplied: bool => dispatch(changeStatusOfFilter(bool)),
    saveFilteredCategory: category => dispatch(saveFilteredCategory(category)),
    saveFilteredLocation: location => dispatch(saveFilteredLocation(location))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CollectionDetailPage)
);



// WEBPACK FOOTER //
// ./src/CollectionDetailPage.jsx